import React from "react";
import ReactDOM from "react-dom/client";

import App from "./App";
import PostponementApp from "./PostponementApp";

// Import Cabinet and Auth entry points
import "./AuthApp";
import "./CabinetApp";

import { Sentry } from "./sentry";

// Main product form
const productRootEl = document.getElementById("custom-api-react");
if (productRootEl) {
  const root = ReactDOM.createRoot(productRootEl as HTMLElement);
  root.render(
    <React.StrictMode>
      <Sentry.ErrorBoundary fallback={<p>Сталася помилка. Спробуйте перезавантажити сторінку.</p>}>
        <App />
      </Sentry.ErrorBoundary>
    </React.StrictMode>
  );
}




const postponementRootEl = document.getElementById("postponement-form-react");
if (postponementRootEl) {
  const root = ReactDOM.createRoot(postponementRootEl as HTMLElement);
  root.render(
    <React.StrictMode>
      <Sentry.ErrorBoundary fallback={<p>Сталася помилка. Спробуйте перезавантажити сторінку.</p>}>
        <PostponementApp />
      </Sentry.ErrorBoundary>
    </React.StrictMode>
  );
}

// Main Dietitian Panel
import { DietitianApp } from "./dietitian/DietitianApp";
const dietPanelRootEl = document.getElementById("diet-panel-react");
if (dietPanelRootEl) {
  const root = ReactDOM.createRoot(dietPanelRootEl as HTMLElement);
  root.render(
    <React.StrictMode>
      <Sentry.ErrorBoundary fallback={<p>Сталася помилка. Спробуйте перезавантажити сторінку.</p>}>
        <DietitianApp />
      </Sentry.ErrorBoundary>
    </React.StrictMode>
  );
}